import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ILineaNegocio, IProducto } from 'src/app/shared/Entities/entities';
import { ProductService } from 'src/app/shared/services/product.service';
import { EventsService } from 'src/app/shared/services/events.service';
import { productosPath } from 'src/app/shared/helpers/constants';

@Component({
  selector: 'app-mis-datos',
  templateUrl: './mis-datos.component.html',
  styleUrls: ['./mis-datos.component.scss'],
})
export class MisDatosComponent implements OnInit {
  segurosIndivuales: IProducto[] = [];
  segurosColectivos: IProducto[] = [];
  // segurosVitalicios: IProducto[] = [];
  private subscriptions: Subscription[] = [];

  productos: IProducto[] = [];
  selectedProd: IProducto;
  lineaProd: string;
  constructor(
    private productService: ProductService,
    private route: ActivatedRoute,
    private eventSrv: EventsService
  ) {}

  ngOnInit() {
    this.eventSrv.addRouteToRouterTree({
      rootPath: productosPath.path,
      path: '',
      label: 'Inicio',
    });

    this.eventSrv.addRouteToRouterTree({
      path: '',
      label: 'Mis Datos',
    });
    const lneaNegocioSubscription = this.productService
      .listarLineaNegocio()
      .subscribe(
        data => {
          this.segurosIndivuales = this.getProducts(data, 'SEGURO INDIVIDUAL');
          this.segurosIndivuales.forEach(element => {
            this.productos.push(element);
          });
          this.segurosColectivos = this.getProducts(data, 'SEGURO COLECTIVO');
          this.segurosColectivos.forEach(element => {
            this.productos.push(element);
          });
          if (this.productos.length === 0) {
            this.productos.push({
              IdPoliza: 0,
              Nombre: 'Sus pólizas no permiten modificación de sus datos',
            });
          }
          const IdPoliza = parseInt(
            this.route.snapshot.paramMap.get('idpoliza'),
            10
          );
          let selectedProdIndex = 0;
          if (!isNaN(IdPoliza)) {
            const found = this.productos.indexOf(
              this.productos.find(x => x.IdPoliza === IdPoliza)
            );
            if (found >= 0) {
              selectedProdIndex = found;
            }
          }
          this.selectedProd = this.productos[selectedProdIndex];
          this.onProdChange(this.selectedProd);
        },

        err => {
          /* this.productos.push({
            IdPoliza: 0,
            Nombre: 'Sus pólizas no permiten modificación de sus datos'
          });
          this.selectedProd = this.productos[0]; */
        }
      );

    this.subscriptions.push(lneaNegocioSubscription);

    /* const data = this.productService.getlListaLineaNegocio();
    this.segurosIndivuales = this.getProducts(data, 'SEGURO INDIVIDUAL');
    this.segurosIndivuales.forEach(element => {
      this.productos.push(element);
    });
    this.segurosColectivos = this.getProducts(data, 'SEGURO COLECTIVO');
    this.segurosColectivos.forEach(element => {
      this.productos.push(element);
    });
    if (this.productos.length === 0) {
      this.productos.push({
        IdPoliza: 0,
        Nombre: 'Sus pólizas no permiten modificación de sus datos'
      });
    }
    this.selectedProd = this.productos[0];
    this.onProdChange(this.selectedProd); */
  }

  onProdChange(item) {
    this.selectedProd = item;
    if (
      this.segurosIndivuales.find(
        x => x.IdPoliza === this.selectedProd.IdPoliza
      )
    ) {
      this.lineaProd = 'INDIVIDUAL';
    } else if (
      this.segurosColectivos.find(
        x => x.IdPoliza === this.selectedProd.IdPoliza
      )
    ) {
      this.lineaProd = 'COLECTIVO';
    }
  }

  getProducts(data: ILineaNegocio[], lineaNegocio) {
    const lista = data.find(d => d.LineaNegocio === lineaNegocio);
    if (!lista) {
      return [];
    }
    return lista.ListaProductos.Producto;
  }
}
